export const translationNavigation_da_part1 = {
  conversations: "Samtaler",
  uploadData: "Upload information",
  behaviourStudio: "Adfærd",
  missingInfoTickets: "Manglende Info",
  statistics: "Statistik",
  logout: "Log ud",
  profileSettings: "Profilindstillinger",
  profileSettingsDescription: "Administrer dit sprog, dine emailnotifikationer og dit udseende.",
  languageLabel: "Sprog",
  languageSystem: "System",
  languageEnglish: "Engelsk",
  languageDanish: "Dansk",
  allChatbots: "Alle Chatbots",
  Chatbot: "Chatbot",
  widgetUi: "Widget UI",
  users: "Brugere",
  solutions: "Løsninger",
  developer: "Udvikler",
  connectAi: "MCP Connect",
  visitorBlocks: "Blokerede besøgende",
  integrations: "Integrationer",
  organizations: "Organisationer",
  livechat: "Livechat",
  mentionNotificationsNavBadge: "Ulæste omtaler af dig",
  mentionToastTitle: "Du er blevet nævnt",
  mentionToastBody: "Nogen har nævnt dig i en samtale.",
  mentionToastOpen: "Åbn samtale",
  notificationClose: "Luk notifikation",
  livechatNotificationToast: "Ny aktivitet i live chat",
  livechatNotificationToastOpen: "Åbn live chat",
  livechatNotificationOsTitle: "Live chat",
  livechatNotificationOsBody: "Ny aktivitet i live chat venter på dig.",
  customerOverview: "Økonomisk overblik",
  productAnalytics: "Produktanalyse",
  testPortals: "Test-portaler",

  // Financial overview (/revenue)

  // Financial overview (/revenue)
  financialOverviewDescriptionBefore:
    "MRR beregnes som løbende sum af alle betalingshændelser pr. organisation (",
  financialOverviewDescriptionAfter:
    "). Grafen viser månedlig delta og den akkumulerede MRR over de seneste 12 måneder.",
  financialOverviewRefresh: "Opdater",
  financialOverviewFetchError: "Kunne ikke hente data",
  financialOverviewChartTotalMrrLegend: "Samlet MRR (løbende sum)",
  financialOverviewChartDeltaLegend: "Ændring i måneden (delta)",
  financialOverviewChartGoalLegend: "MRR-mål",
  financialOverviewChartTab: "Overblik",
  financialOverviewGoalsTab: "Målindstillinger",
  financialOverviewGoalsDescription:
    "Angiv et MRR-mål for hver måned. Gemte mål vises som en stiplet linje i grafen.",
  financialOverviewGoalsSave: "Gem mål",
  financialOverviewChartYTitleMrr: "MRR (DKK)",
  financialOverviewChartYTitleDelta: "Delta (DKK)",
  financialOverviewKpiTotalMrr: "Samlet MRR",
  financialOverviewKpiPayingOrgs: "Betalende organisationer",
  financialOverviewKpiAvgMrrPaying: "Gns. MRR (betalende)",
  financialOverviewKpiLatestMonth: "Seneste måned",
  financialOverviewKpiDeltaSublabel: "Delta i kalendermåned",
  financialOverviewMrrOverTime: "MRR over tid",
  financialOverviewNoMonthlySeries: "Ingen månedsserier endnu.",
  financialOverviewOrganizations: "Organisationer",
  financialOverviewRowCount: "{count} rækker",
  financialOverviewColOrganization: "Organisation",
  financialOverviewColCurrentMrr: "Nuværende MRR",
  financialOverviewColConversationsLast30Days: "Samtaler (30 dage)",
  financialOverviewColPricePerConversation: "Pris pr. samtale",
  financialOverviewColDetails: "Detaljer",
  financialOverviewCtaBusiness: "Forretning",
  financialOverviewNoOrgsFound: "Ingen organisationer fundet.",
  financialOverviewNoMatchingOrgs: "Ingen organisationer matcher din søgning eller filtre.",
  financialOverviewSearchPlaceholder: "Søg organisationer…",
  financialOverviewSearchAriaLabel: "Søg organisationer efter navn eller Keycloak-id",
  financialOverviewFilterPayingOnly: "Kun betalende",
  financialOverviewRowCountFiltered: "{filtered} af {total} rækker",
  financialOverviewMissingKeycloakTitle: "Mangler Keycloak-organisations-id",
  financialOverviewTooltipPaymentEvents: "Betalingshændelser",
  financialOverviewTooltipNoEvents: "Ingen betalingshændelser denne måned",
  financialOverviewEventTypeIncrease: "Stigning",
  financialOverviewEventTypeDecrease: "Fald",
  financialOverviewEventTypeChurn: "Churn",

  // Scope picker (sidebar — org / brand / chatbot)

  // Scope picker (sidebar — org / brand / chatbot)
  scopePickerAllChatbots: "Alle chatbots",
  scopePickerAllCustomers: "Alle kunder",
  scopePickerSearchPlaceholder: "Søg (tryk / for fokus)",
  scopePickerRecent: "Seneste",
  scopePickerNoChatbots: "Ingen chatbots tilgængelige",
  scopePickerChatbotCountOne: "1 chatbot",
  scopePickerChatbotCountMany: "{n} chatbots",
  scopePickerExpand: "Udvid",
  scopePickerCollapse: "Fold sammen",
  scopePickerOrgUnavailable: "(Organisation ikke tilgængelig)",
  scopePickerBrandUnavailable: "(Brand ikke tilgængelig)",

  // Test chatbot widget (floating picker in the dashboard)

  // Test chatbot widget (floating picker in the dashboard)
  testChatbotTesting: "Tester",
  testChatbotChoose: "Vælg en chatbot",
  testChatbotAuto: "Auto (følger valgt scope)",
  testChatbotSearchPlaceholder: "Søg chatbot...",
  testChatbotNoResults: "Ingen chatbots matcher",
  testChatbotHide: "Skjul widget",
  testChatbotShow: "Vis test-chatbot",

  agentNamePlaceholder: "Indtast dit agentnavn",
  livechatConversations: "Samtaler",
  livechatSettings: "Indstillinger",
  goToLivechat: "Gå til livechat",
  livechatAvailable: "Denne samtale er tilgængelig i livechat tilstand...",

  // Chatbot configuration translations

  // Chatbot configuration translations
  themeColor: "Primær farve",
  darkMode: "Mørk tilstand",
  enableDarkMode: "Aktivér mørk tilstand",
  lightModeTab: "Lys",
  darkModeTab: "Mørk",
  darkModePreviewHint:
    "Forhåndsvisningen viser lys tilstand. Mørk tilstand leveres via chatbot-API'et.",
  backgroundColor: "Chatbaggrund",
  backgroundGradientColor: "Baggrundsgradient",
  headerButtonBackgroundColor: "Header-knap baggrund",
  headerButtonIconColor: "Header-knap ikon",
  secondaryTextColor: "Dæmpet tekst",
  aiMessageColor: "Assistent-besked",
  aiMessageTextColor: "Assistent-besked tekst",
  aiMessageBorderColor: "Assistent-besked kant",
  aiMessageThinkingBorderGradient: "Assistent-besked tænke-kant",
  addGradientStop: "Tilføj gradient stop",
};
